const handleDeleteEquipment = {
  confirm1: '¿Realmente quieree eliminar el dispositivo?',
  confirm2: 'Se eliminarán todos los servicios y acciones relacionados a este equipo.',
  confirm3: '¿Realmente desea eliminar estos dispositivos?',
  title: 'ELIMINAR EQUIPO',
  title2: 'ELIMINAR EQUIPOS',
};

export default handleDeleteEquipment;
